import { PLATINUM_SPONSOR } from "../../../../../common/constants/sponsor-constants";
import { BasicSponsor } from "../../Sponsorship/Sponsorship";
import SponsorDetail from "../SponsorDetail";

type Sponsor = { isPlatinum: boolean } & BasicSponsor;

type Props = {
  sponsor: Sponsor;
  platinumSponsor: BasicSponsor;
  fosterSponsor: Sponsor;
};

const LeafPlatinumSponsor = (props: Props) => {
  const { sponsor, platinumSponsor, fosterSponsor } = props;
  const isPlatinumSponsor =
    platinumSponsor.isValid === true && sponsor.isPlatinum === false && fosterSponsor.isPlatinum === false;

  return (
    <SponsorDetail
      sponsor={{
        ...platinumSponsor,
        isPlatinum: true,
      }}
      show={isPlatinumSponsor}
      sponsorType={PLATINUM_SPONSOR}
    />
  );
};

export default LeafPlatinumSponsor;
